var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromptClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7637 0.950207C10.4442 1.26973 10.4442 1.78777 10.7637 2.10729L19.0561 10.3997C20.7609 12.1045 20.7609 14.8661 19.0561 16.5708C17.3514 18.2756 14.5898 18.2756 12.885 16.5708L3.24264 6.92847C2.17812 5.86396 2.17812 4.13604 3.24264 3.07153C4.30716 2.00701 6.03507 2.00701 7.09959 3.07153L15.1992 11.1711C15.6234 11.5954 15.6234 12.2896 15.1992 12.7139C14.7749 13.1382 14.0807 13.1382 13.6564 12.7139L6.90674 5.96424C6.58722 5.64472 6.06918 5.64472 5.74966 5.96424C5.43014 6.28376 5.43014 6.8018 5.74966 7.12132L12.4993 13.871C13.5638 14.9355 15.2917 14.9355 16.3563 13.871C17.4208 12.8065 17.4208 11.0785 16.3563 10.014L8.25667 1.91444C6.5519 0.209673 3.79033 0.209673 2.08556 1.91444C0.380787 3.61921 0.380787 6.38079 2.08556 8.08556L11.7279 17.7279C14.0729 20.0729 17.8682 20.0729 20.2132 17.7279C22.5582 15.3829 22.5582 11.5877 20.2132 9.24264L11.9208 0.950208C11.6013 0.630688 11.0832 0.630687 10.7637 0.950207Z",
    fill: "#0085FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromptClip);
export default __webpack_public_path__ + "static/media/promptClip.7fd0a34c88a53ea6753b231111d1f79b.svg";
export { ForwardRef as ReactComponent };